export default {"src":"/_next/static/media/checklist.76e02aaa.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};